import { useState, useEffect, useRef  } from "react";
import Modal from "react-modal";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import api from "../../services/api";
import { useNavigate, Link } from "react-router-dom";

import Swal from "sweetalert2";
import Autosuggest from 'react-autosuggest';
import EventTagInput from "../common/EventTagInput";
import { calcularSemanaEpidemiologica } from "../../common/epidemiologia";

// IMPORTS LIBRERIAS PROPIAS //
import { usePatologia } from "../../context/PatologiaContext";
import { useZona } from "../../context/ZonaContext";
import "../../css/Contactos.css"


const AddContactos = () => {
    // Autocompletado de direcciones (Nominatim)
    const [sugerenciasDireccion, setSugerenciasDireccion] = useState([]);
    const [buscandoDireccion, setBuscandoDireccion] = useState(false);
    const timeoutDireccion = useRef(null);
  // Localidad/Dirección (Leaflet)
  const [direccion, setDireccion] = useState("");
  const [coordenadas, setCoordenadas] = useState(null); // {lat, lng}
  const [modalMapaAbierto, setModalMapaAbierto] = useState(false);
  const [zonaGeografica, setZonaGeografica] = useState(null); // IdZonaGeografica

  // Abrir/cerrar modal
  const handleAbrirMapa = () => setModalMapaAbierto(true);
  const handleCerrarMapa = () => setModalMapaAbierto(false);

  // Leaflet marker icon fix (default icon bug)
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });

  const obtenerDireccionPorCoordenadas = async ({ lat, lng }) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
      );
      const data = await response.json();
      return data.display_name || "";
    } catch {
      return "";
    }
  };

  // Componente para seleccionar punto en el mapa
  function LocationMarker() {
    useMapEvents({
      async click(e) {
        setCoordenadas(e.latlng);
        const direccionEncontrada = await obtenerDireccionPorCoordenadas(e.latlng);
        setDireccion(direccionEncontrada || "Ubicacion seleccionada en mapa");
      },
    });
    return coordenadas ? <Marker position={coordenadas} /> : null;
  }

  // Confirmar selección y cerrar modal
  const handleSeleccionarDireccion = () => {
    setModalMapaAbierto(false);
  };
  const autosuggestTheme = {
  suggestion: "autosuggest-item",
  suggestionHighlighted: "autosuggest-item-hover",
};
  const [sugerencias, setSugerencias] = useState([]);
  const [sugerenciasDni, setSugerenciasDni] = useState([])
 const [tiposDocumentoPorPais, setTiposDocumentoPorPais] = useState([]);
const [nombreCase, setNombreCase] = useState("");
const [apellidoCase, setApellidoCase] = useState("");
const dniInputRef = useRef(null);
  const [documentCaseNumber, setDocumentCaseNumber] = useState("");
const [tiposDocumentoActivos, setTiposDocumentoActivos] = useState([]);
  const [personaCase, setPersonaCase] = useState(null);
const [bloquear, setBloquear] = useState(false);
const [patologiaUsuario, setPatologiaUsuario] = useState(null);
const [atributosSeleccionados, setAtributosSeleccionados] = useState([]);
const [atributosDisponibles, setAtributosDisponibles] = useState([]);

const [mensaje, setMensaje] = useState("");
const [persona, setPersona] = useState(null);
  const [CaseError, setErrorCase] = useState("")
  const [ContactError, setContactError] = useState("")
  const [personaContacto, setPersonaContacto] = useState(null);

  const [comorbilidadesDisponibles, setComorbilidadesDisponibles] = useState([]);
  const [comorbilidadesSeleccionadas, setComorbilidadesSeleccionadas] = useState([]);

  const [Email, setEmail] = useState("");
  const [Telefono, setTelefono] = useState("");
  const [Observaciones, setObservaciones] = useState("");
  const [Eventos, setEventos] = useState("");
  const [mostrarEventosCampo, setMostrarEventosCampo] = useState(false);
  const [Nombre, setNombre] = useState("");
  const [Apellido, setApellido] = useState("");
  const [FechaNacimiento, setFechaNacimiento] = useState("");
  const [Edad, setEdad] = useState(0);
  const [IdGrupoEtario, setIdGrupoEtario] = useState("");
  const [IdEstablecimientoDiagnostico, setIdEstablecimientoDiagnostico] = useState("");
  const [establecimientosDiagnostico, setEstablecimientosDiagnostico] = useState([]);
  const [IdSector, setIdSector] = useState("");
  const [IdSubsector, setIdSubsector] = useState("");
  const [sectores, setSectores] = useState([]);
  const [subsectores, setSubsectores] = useState([]);
  const [IdAreaZona, setIdAreaZona] = useState("");
  const [IdAreaProgramatica, setIdAreaProgramatica] = useState("");
  const [areasZonas, setAreasZonas] = useState([]);
  const [areasProgramaticas, setAreasProgramaticas] = useState([]);
  const [IdInstitucionSeguimientoTratamiento, setIdInstitucionSeguimientoTratamiento] = useState("");
  const [institucionesSeguimientoTratamiento, setInstitucionesSeguimientoTratamiento] = useState([]);
  const [IdEvolucionClinicoTerapeutica, setIdEvolucionClinicoTerapeutica] = useState("");
  const [evolucionesClinicoTerapeuticas, setEvolucionesClinicoTerapeuticas] = useState([]);
  const [gruposEtarios, setGruposEtarios] = useState([]);
  const [Sexo, setSexo] = useState("");
  const [Genero, setGenero] = useState("");
const [zonaSanitariaUsuario, setZonaSanitariaUsuario] = useState(null);
const [zonas, setZonas] = useState([]);
const idUsuario = localStorage.getItem("idUsuario");
const { patologiaActiva } = usePatologia();
const { zonaActiva } = useZona();
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [IdDocumento, setIdDocumento] = useState("");
  const [IdPais, setIdPais] = useState(0);
  const [nombrePais, setNombrePais] = useState([]);

  const [isConviviente, setIsConviviente] = useState(false);

  const [relacion, setRelacion] = useState("")
  const [TiposDeRelaciones, setTiposDeRelaciones] = useState([]);
const [patologia, setPatologia] = useState("");
const [patologiaNombre, setPatologiaNombre] = useState("Cargando...");
const [TiposDePatologia, setTiposDePatologia] = useState([]);
const [patologiasCargadas, setPatologiasCargadas] = useState(false);

  const [fechaActual, setFechaActual] = useState("");
  const [fechaSintomas, setFechaSintomas] = useState("");
  const [desconoceFechaSintomas, setDesconoceFechaSintomas] = useState(false);
  const [fechaExposicion, setFechaExposicion] = useState("");
  const [desconoceFechaExposicion, setDesconoceFechaExposicion] = useState(false);
  const [fechaConsulta, setFechaConsulta] = useState("");
  const [FechaApertura, setFechaApertura] = useState("");
  const [desconoceFechaApertura, setDesconoceFechaApertura] = useState(false);
  const [FechaNotificacion, setFechaNotificacion] = useState("");
  const [desconoceFechaNotificacion, setDesconoceFechaNotificacion] = useState(false);
  const [SemanaEpidemiologica, setSemanaEpidemiologica] = useState("");
  const [ClasificacionInicioTratamiento, setClasificacionInicioTratamiento] = useState("");
  const [FechaInicioTratamiento, setFechaInicioTratamiento] = useState("");
  const [desconoceFechaInicioTratamiento, setDesconoceFechaInicioTratamiento] = useState(false);
  const [FechaFinTratamiento, setFechaFinTratamiento] = useState("");
  const [desconoceFechaFinTratamiento, setDesconoceFechaFinTratamiento] = useState(false);
  const [ResultadoTratamiento, setResultadoTratamiento] = useState("");
  const [estadosTratamiento, setEstadosTratamiento] = useState([]);
  const [desconoceFechaConsulta, setDesconoceFechaConsulta] = useState(false);

  const [botonGuardarPersonaActivo, setBotonGuardarPersonaActivo] = useState(false);
const [errorFechaExposicion, setErrorFechaExposicion] = useState("");
const [errorFechaSintomas, setErrorFechaSintomas] = useState("");
const [errorFechaConsulta, setErrorFechaConsulta] = useState("");
const validarFechaExposicion = (e) => {
  const valor = e.target.value;
  const hoy = new Date();
  const fechaIngresada = new Date(valor);

  if (fechaIngresada > hoy) {
    setFechaExposicion("");
    setErrorFechaExposicion("⚠️ La fecha no puede ser posterior al día actual.");
    Swal.fire({
      icon: 'warning',
      title: 'Fecha inválida',
      text: 'La fecha de exposición no puede ser posterior al día actual.',
    });
    return;
  }

  if (fechaSintomas && fechaIngresada > new Date(fechaSintomas)) {
    setFechaExposicion("");
    setErrorFechaExposicion("⚠️ La fecha de exposición debe ser anterior a la de síntomas.");
    Swal.fire({
      icon: 'warning',
      title: 'Fecha inválida',
      text: 'La fecha de exposición debe ser anterior a la fecha de inicio de síntomas.',
    });
    return;
  }

  setFechaExposicion(valor);
  setErrorFechaExposicion("");
};

const validarFechaSintomas = (e) => {
  const valor = e.target.value;
  const hoy = new Date();
  const fechaIngresada = new Date(valor);

  if (fechaIngresada > hoy) {
    setFechaSintomas("");
    setErrorFechaSintomas("⚠️ La fecha no puede ser posterior al día actual.");
    Swal.fire({
      icon: 'warning',
      title: 'Fecha inválida',
      text: 'La fecha de síntomas no puede ser posterior al día actual.',
    });
    return;
  }

  if (fechaExposicion && new Date(fechaExposicion) > fechaIngresada) {
    setFechaSintomas("");
    setErrorFechaSintomas("⚠️ La fecha de síntomas debe ser posterior a la de exposición.");
    Swal.fire({
      icon: 'warning',
      title: 'Fecha inválida',
      text: 'La fecha de síntomas debe ser posterior a la fecha de exposición.',
    });
    return;
  }

  setFechaSintomas(valor);
  setErrorFechaSintomas("");
};

const validarFechaConsulta = (e) => {
  const valor = e.target.value;
  setFechaConsulta(valor);

  const hoy = new Date();
  const fechaIngresada = new Date(valor);

  if (fechaIngresada > hoy) {
    setErrorFechaConsulta("⚠️ La fecha no puede ser posterior al día actual.");
  } else {
    setErrorFechaConsulta("");
  }
};

const limpiarFormularioContacto = () => {
  setDireccion("");
  setCoordenadas(null);
  setZonaGeografica(null);
  setSugerenciasDireccion([]);
  setModalMapaAbierto(false);

  setNombre("");
  setApellido("");
  setFechaNacimiento("");
  setEdad("");
  setSexo("");
  setGenero("");
  setEmail("");
  setTelefono("");
  setObservaciones("");
  setEventos("");
  setIdDocumento("");
  setContactError("");
  setIdSector("");
  setIdSubsector("");
  setIdAreaZona("");
  setIdAreaProgramatica("");

  setRelacion("");
  setIsConviviente(false);

  setFechaSintomas("");
  setDesconoceFechaSintomas(false);
  setFechaExposicion("");
  setDesconoceFechaExposicion(false);
  setFechaConsulta("");
  setFechaApertura("");
  setDesconoceFechaApertura(false);
  setFechaNotificacion("");
  setDesconoceFechaNotificacion(false);
  setSemanaEpidemiologica("");
  setClasificacionInicioTratamiento("");
  setFechaInicioTratamiento("");
  setDesconoceFechaInicioTratamiento(false);
  setFechaFinTratamiento("");
  setDesconoceFechaFinTratamiento(false);
  setResultadoTratamiento("");
  setDesconoceFechaConsulta(false);

  setErrorFechaExposicion("");
  setErrorFechaSintomas("");
  setErrorFechaConsulta("");

  setComorbilidadesSeleccionadas([]);
  setAtributosSeleccionados([]);

  setPersonaCase(null);
  setNombreCase("");
  setApellidoCase("");
  setDocumentCaseNumber("");
  setErrorCase("");

  setMensaje("");
  setBloquear(false);
};

const crearSeguimientoAutomatico = async (idPersona) => {
  try {
    const idUsuarioLocal = idUsuario || localStorage.getItem("idUsuario");
    const idZona = zonaSanitariaUsuario ? Number(zonaSanitariaUsuario.IdZonaSanitaria) : null;
    const idPat = patologia ? Number(patologia) : null;

    const datosSeguimiento = {
      idPersona: Number(idPersona),
      idPatologia: idPat,
      idZonaSanitaria: idZona,
      idUsuario: idUsuarioLocal ? Number(idUsuarioLocal) : null,
      
      fechaInicio: new Date().toISOString().slice(0,19).replace('T',' '),
      observaciones: "Seguimiento creado automáticamente al registrar contacto"
    };

    console.log("📋 Datos del seguimiento (pre-post):", datosSeguimiento);

    const res = await api.post(`/seguimientos`, datosSeguimiento, { headers: { "Content-Type": "application/json" } });

    // Mostrar alertas si hay reglas activadas
    if (res.data?.evaluacionReglas?.reglasActivadas?.length > 0) {
      res.data.evaluacionReglas.reglasActivadas.forEach(regla => {
        Swal.fire({
          icon: 'warning',
          title: '¡Atención! Regla activada',
          text: regla.Accion || regla.mensaje || 'Se activó una regla.'
        });
      });
    }

    console.log("✅ Seguimiento creado automáticamente, respuesta:", res.data);
    return res.data;
  } catch (error) {
    console.error("❌ Error al crear seguimiento automático:", 
      error?.response?.data || error?.message || error);
    // opcional: devolver el error para manejo superior
    throw error;
  }
};

  useEffect(() => {
    api.get("/grupos-etarios")
      .then(({ data }) => setGruposEtarios(data.filter((grupo) => Number(grupo.Estado) === 1)))
      .catch((error) => console.error("Error al obtener grupos etarios:", error));
  }, []);

  useEffect(() => {
    api.get("/establecimientos-diagnostico")
      .then(({ data }) => setEstablecimientosDiagnostico(data.filter((item) => Number(item.Estado) === 1)))
      .catch((error) => console.error("Error al obtener establecimientos de diagnóstico:", error));
  }, []);

  useEffect(() => {
    Promise.all([api.get("/sectores"), api.get("/subsectores")])
      .then(([respuestaSectores, respuestaSubsectores]) => {
        setSectores(respuestaSectores.data.filter((item) => Number(item.Estado) === 1));
        setSubsectores(respuestaSubsectores.data.filter((item) => Number(item.Estado) === 1 && Number(item.EstadoSector) === 1));
      })
      .catch((error) => console.error("Error al obtener sectores y subsectores:", error));
  }, []);

  useEffect(() => {
    Promise.all([api.get("/areas-zonas"), api.get("/areas-programaticas")])
      .then(([zonas, areas]) => {
        setAreasZonas(zonas.data.filter((item) => Number(item.Estado) === 1));
        setAreasProgramaticas(areas.data.filter((item) => Number(item.Estado) === 1 && Number(item.EstadoAreaZona) === 1));
      })
      .catch((error) => console.error("Error al obtener zonas y áreas programáticas:", error));
  }, []);

  useEffect(() => {
    Promise.all([api.get("/instituciones-seguimiento-tratamiento"), api.get("/evoluciones-clinico-terapeuticas")])
      .then(([instituciones, evoluciones]) => {
        setInstitucionesSeguimientoTratamiento(instituciones.data.filter((item) => Number(item.Estado) === 1));
        setEvolucionesClinicoTerapeuticas(evoluciones.data.filter((item) => Number(item.Estado) === 1));
      })
      .catch((error) => console.error("Error al obtener catálogos de tratamiento:", error));
  }, []);

  useEffect(() => {
    const edadNumerica = Number(Edad);
    const sugerido = gruposEtarios.find(
      (grupo) => edadNumerica >= Number(grupo.EdadDesde) && edadNumerica <= Number(grupo.EdadHasta)
    );
    setIdGrupoEtario(sugerido ? String(sugerido.IdGrupoEtario) : "");
  }, [Edad, gruposEtarios]);

  useEffect(() => {
    if (!patologia) return setEstadosTratamiento([]);
    api.get(`/estados-tratamiento-por-patologia/${patologia}`)
      .then(({ data }) => setEstadosTratamiento(data.filter((item) => Number(item.estado) === 1 && Number(item.EstadoCatalogo) === 1)))
      .catch(() => setEstadosTratamiento([]));
  }, [patologia]);

  const actualizarFechaNacimiento = (fecha) => {
    setFechaNacimiento(fecha);
    if (!fecha) return;

    const nacimiento = new Date(`${fecha}T00:00:00`);
    const hoy = new Date();
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const aunNoCumplio = hoy.getMonth() < nacimiento.getMonth()
      || (hoy.getMonth() === nacimiento.getMonth() && hoy.getDate() < nacimiento.getDate());
    if (aunNoCumplio) edad -= 1;
    if (edad >= 0 && edad <= 120) setEdad(String(edad));
  };

  useEffect(() => {
    const cargarComorbilidades = async () => {
      if (patologia) {
        try {
          const response = await api.get(`/comorbilidades/${patologia}`);
          setComorbilidadesDisponibles(response.data.filter(c => Number(c.estadoRelacion) === 1));
          setComorbilidadesSeleccionadas([]); // Resetear selecciones al cambiar patología
        } catch (error) {
          console.error("Error al cargar comorbilidades:", error);
          setComorbilidadesDisponibles([]);
        }
      } else {
        setComorbilidadesDisponibles([]);
        setComorbilidadesSeleccionadas([]);
      }
    };

    cargarComorbilidades();
  }, [patologia]);


useEffect(() => {
  if (patologia) {
    getAtributosPorPatologia(patologia);
  }
}, [patologia]);


useEffect(() => {
  if (!idUsuario) return;

  api
    .get(`/usuarios/${idUsuario}`)
    .then(res => {
      const zonasAsignadas = res.data.zonasAsignadas || [];
      setZonas(zonasAsignadas);

      let zonaSeleccionada = null;

      if (zonaActiva) {
        zonaSeleccionada = zonasAsignadas.find(z => z.Nombre === zonaActiva) || null;
      }

      if (!zonaSeleccionada) {
        zonaSeleccionada =
          res.data.zonaActiva || zonasAsignadas.find(z => z.EsDefault === 1) || null;
      }

      setZonaSanitariaUsuario(zonaSeleccionada);
    })
    .catch(err => console.error("Error al obtener la zona sanitaria:", err));
}, [idUsuario, zonaActiva]);

useEffect(() => {
  if (!zonaActiva) return;

  if (zonas.length > 0) {
    const zonaSeleccionada = zonas.find(z => z.Nombre === zonaActiva);
    if (zonaSeleccionada) {
      setZonaSanitariaUsuario(zonaSeleccionada);
      return;
    }
  }

  const idZonaLocal = localStorage.getItem("idZonaActiva");
  const idZonaNumero = idZonaLocal ? parseInt(idZonaLocal, 10) : NaN;

  if (!Number.isNaN(idZonaNumero)) {
    setZonaSanitariaUsuario(prev => ({
      ...(prev || {}),
      IdZonaSanitaria: idZonaNumero,
      Nombre: zonaActiva,
    }));
    return;
  }

  setZonaSanitariaUsuario(prev =>
    prev ? { ...prev, Nombre: zonaActiva } : { Nombre: zonaActiva }
  );
}, [zonaActiva, zonas]);


useEffect(() => {
  if (dniInputRef.current) {
    dniInputRef.current.focus();
  }
}, []);



useEffect(() => {
  const getTiposDocumentoActivos = async () => {
    try {
      const response = await api.get(`/tipodocumentos`);
      const activos = response.data.filter(t => t.estado === 1);
      setTiposDocumentoActivos(activos);
    } catch (err) {
      console.error("Error al cargar tipos de documento activos:", err);
    }
  };

  getTiposDocumentoActivos();
}, []);


const obtenerIdEstadoPorNombreOSistema = async () => {
  try {
    const r = await api.get(`/estados`); // adaptá ruta real
    const estados = r.data;
    // Buscar por nombre
    let estado = estados.find(e => e.Nombre && e.Nombre.toUpperCase() === 'EN SEGUIMIENTO');
    // Si no, buscar uno de sistema
    if (!estado) estado = estados.find(e => Number(e.DeSistema) === 1);
    return estado ? Number(estado.IdEstado || estado.id || estado.Id) : null;
  } catch (e) {
    console.error("No se pudieron obtener estados:", e);
    return null;
  }
};


const asociarComorbilidadesAPersona = async (idPersona, idPatologia) => {
  try {
    if (!comorbilidadesSeleccionadas || comorbilidadesSeleccionadas.length === 0) return;

    await api.post(`/comorbilidadesxpersonaxpatologia`, {
      IdPersona: idPersona,
      IdPatologia: idPatologia,
      comorbilidades: comorbilidadesSeleccionadas.map(Number)
    });

    console.log('Comorbilidades asociadas correctamente');

    alert('Comorbilidades asociadas correctamente a persona y patología.');
  } catch (error) {
    console.error('Error al asociar comorbilidades:', error);
    alert('Error al asociar comorbilidades.');
  }
};
const BuscarContactoExistente = async (dni) => {
  if (!dni) return;

  // 🟢 Validar longitud
  if (dni.length > 8) {
    setMensaje("El DNI supera el límite de 8 números.");
    setBloquear(false);
    return;
  }

  try {
    const response = await api.get(`/buscarNroDocumentoExistente/${dni}`);

    const data = response.data;

    if (data.existe) {
      setPersona(data.persona);

      if (data.tieneClasificaciones && data.clasificaciones.length > 0) {
        // 🔍 Buscar coincidencias
        const coincidencia = data.clasificaciones.find(
          (c) =>
            c.Patologia === patologiaUsuario?.Nombre &&
            c.ZonaSanitaria === zonaSanitariaUsuario?.Nombre
        );

        if (coincidencia) {
          // 🔴 Misma zona/patología
          setBloquear(true);
          setMensaje(
            `⚠️ Atención:\nEsta persona ya está registrada con la patología "${coincidencia.Patologia}" en la zona "${coincidencia.ZonaSanitaria}".\nNo se puede volver a registrar.`
          );
          return;
        }

        // 🟢 Otra combinación → se puede crear
        const primera = data.clasificaciones[0];
        setBloquear(false);
        setMensaje(
          `ℹ️ Esta persona ya tiene otros registros, en "${primera.Patologia}" (${primera.ZonaSanitaria}).\nPuede crear un nuevo registro con otra patología o zona.`
        );
      } else {
        // 🟡 No tiene registros previos
        setBloquear(false);
        setMensaje("Esta persona no tiene registros previos.");
      }
    } else {
      // 🟡 DNI no encontrado
      setPersona(null);
      setBloquear(false);
      setMensaje("DNI no registrado aún. Puede continuar con la carga.");
    }
  } catch (error) {
    console.error("", error);
    setMensaje("");
    setBloquear(false);
  }
};

const getAtributosPorPatologia = async (idPatologia) => {
  try {
    const resp = await api.get(`/atributosPorPatologia/${idPatologia}`);
    setAtributosDisponibles((resp.data || []).filter(a => Number(a.estado) === 1));
  } catch (error) {
    console.error("Error cargando atributos:", error);
    setAtributosDisponibles([]);
  }
};


const getCasePorNombreApellido = async () => {
  try {
    const response = await api.get(`/buscarPorNombreApellido`, {
      params: { nombre: nombreCase, apellido: apellidoCase },
    });

    const persona = response.data[0]; // Tomamos el primero si hay más

    if (persona.IdClasificacionPersona === 1) {
      setPersonaCase(persona);
      setErrorCase("");
    } else {
      setPersonaCase(null);
      setErrorCase("La persona no es un caso.");
    }
  } catch (error) {
    setPersonaCase(null);
    setErrorCase("No se encontró el caso por nombre y apellido.");
    console.error("Error en búsqueda por nombre y apellido:", error);
  }
};





  // CONSTANTES //
  const navigate = useNavigate();
  //----------------------------------------------
  //----------------------------------------------
  // ----------------useEffect--------------------
  //----------------------------------------------
  //----------------------------------------------
  useEffect(
    () => {

      FechaHoy();
    },
    []
  );

useEffect(() => {
  getPaises(); // Carga automática de países al entrar
}, []);

useEffect(() => {
  if (IdPais) {
    getTiposDocumentoActivosPorPais(IdPais);
  }
}, [IdPais]);
 

  useEffect(
    () => {
      try {
        // if (personaCase == null){
        //   setBotonGuardarPersonaActivo(false);
        //   console.error("PersonaCase == Null");
        // }

        // if (IdPais <= 0){
        //   setBotonGuardarPersonaActivo(false);
        //   console.error("IdPais <= 0");
        // }

        // if (Nombre.length <= 0){
        //   setBotonGuardarPersonaActivo(false);
        //   console.error("Nombre.length <= 0");
        // }

        // if (Apellido.length <= 0){
        //   setBotonGuardarPersonaActivo(false);
        //   console.error("Apellido.length <= 0");
        // }


        // if (IdDocumento.length <= 0){
        //   setBotonGuardarPersonaActivo(false);
        //   console.error("IdDocumento.length <= 0");
        // }

        // if (ContactError != "" ){
        //   setBotonGuardarPersonaActivo(false);
        //   console.error('ContactError != ""');
        // }

        // if (Edad <= 0){
        //   setBotonGuardarPersonaActivo(false);
        //   console.error("Edad <= 0");
        // }

        // if (Sexo.length <= 0){
        //   setBotonGuardarPersonaActivo(false);
        //   console.error("Sexo.length <= 0");
        // }

        // if(patologia == ""){
        //   setBotonGuardarPersonaActivo(false);
        //   console.error('patologia == ""');
        // }

        // if(relacion == ""){
        //   setBotonGuardarPersonaActivo(false);
        //   console.error('relacion == ""');
        // }

        if (relacion != "" && personaCase != null && IdPais > 0 && patologia != "" &&/*Email.length > 0 &&*/ Nombre.length > 0 && Apellido.length > 0 && IdDocumento.length > 0 && ContactError == "" && Edad > 0 && Sexo.length > 0) {
          // console.log("aaaaa");
          setBotonGuardarPersonaActivo(true);
        }

        //console.log("Aca va algo??: ", botonGuardarPersonaActivo);
      }
      catch (err) {
        console.error(err);
      }
    },
    [
      IdPais,
      patologia,
      personaCase,
      IdDocumento,
      Nombre,
      Apellido,
      ContactError,
      Edad,
      Sexo,
      relacion
    ]
  );

  // //----------------------------------------------
  // //----------------------------------------------
  // // ----------------Funciones--------------------
  // //----------------------------------------------
  // //----------------------------------------------

  const FechaHoy = async () => {
    var today = new Date();
    // `getDate()` devuelve el día del mes (del 1 al 31)
    var day = today.getDate();
    // `getMonth()` devuelve el mes (de 0 a 11)
    var month = today.getMonth() + 1;
    // `getFullYear()` devuelve el año completo
    var year = today.getFullYear();
    // `getHours()` devuelve la hora
    var horaAux = today.getHours();
    // `getMinutes()` devuelve los minutos
    var minutosAux = today.getMinutes();
    // `getSeconds()` devuelve los segundos
    var segundosAux = today.getSeconds();
    var hora = horaAux.toString().padStart(2, "0");
    var minutos = minutosAux.toString().padStart(2, "0");
    var segundos = segundosAux.toString().padStart(2, "0");
    // muestra la fecha de hoy en formato `MM/DD/YYYY`
    //console.log(`${month}/${day}/${year}`);
    setFechaActual(`${year}-${month}-${day}`);
    //setHora(`${hora}:${minutos}:${segundos}`);
  };

const Subir = async () => {
  if (FechaInicioTratamiento && FechaFinTratamiento && FechaFinTratamiento < FechaInicioTratamiento) {
    return Swal.fire({ icon: "warning", title: "Fechas inválidas", text: "La fecha de fin del tratamiento no puede ser anterior a la fecha de inicio" });
  }
  if (!IdEstablecimientoDiagnostico) {
    return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná el establecimiento de diagnóstico" });
  }
  if (!IdSector) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná el sector" });
  if (!IdAreaZona) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná la zona" });
  if (!IdInstitucionSeguimientoTratamiento) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná la institución de seguimiento del tratamiento" });
  if (!IdEvolucionClinicoTerapeutica) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná la evolución clínico-terapéutica" });
  try {
   if (!personaCase) {
  return Swal.fire("Falta completar", "Debe seleccionar un caso por DNI o por nombre y apellido.", "error");
}

    if (!IdPais) {
      return Swal.fire("Falta completar", "Debe seleccionar una nacionalidad.", "error");
    }

    if (!tipoDocumento) {
      return Swal.fire("Falta completar", "Debe seleccionar el tipo de documento.", "error");
    }

    if (!IdDocumento) {
      return Swal.fire("Falta completar", "Debe ingresar un número de documento.", "error");
    }

    if (ContactError && ContactError !== "") {
      return Swal.fire("Duplicado", "El número de documento ya está registrado.", "warning");
    }

    if (!Nombre) {
      return Swal.fire("Falta completar", "Debe ingresar el nombre del contacto.", "error");
    }

    if (!Apellido) {
      return Swal.fire("Falta completar", "Debe ingresar el apellido del contacto.", "error");
    }

    if (!Edad || Edad <= 0) {
      return Swal.fire("Falta completar", "Debe ingresar una edad válida.", "error");
    }

    if (!Sexo) {
      return Swal.fire("Falta completar", "Debe seleccionar el sexo.", "error");
    }

    if (!Genero) {
  return Swal.fire("Falta completar", "Debe seleccionar el género.", "error");
}

    if (!Telefono) {
      return Swal.fire("Falta completar", "Debe ingresar el teléfono.", "error");
    }

    if (!patologia) {
      return Swal.fire("Falta completar", "Debe seleccionar una patología.", "error");
    }

    if (!relacion) {
      return Swal.fire("Falta completar", "Debe seleccionar una relación.", "error");
    }

    if (!desconoceFechaExposicion && !fechaExposicion) {
  return Swal.fire("Falta completar", "Debe ingresar la fecha de exposición o marcar que se desconoce.", "error");
}
if (!desconoceFechaSintomas && !fechaSintomas) {
  return Swal.fire("Falta completar", "Debe ingresar la fecha de síntomas o marcar que se desconoce.", "error");
}
if (!desconoceFechaConsulta && !fechaConsulta) {
  return Swal.fire("Falta completar", "Debe ingresar la fecha de consulta o marcar que se desconoce.", "error");
}

    // Si todo está validado, continúa
    await createPersona();
    Swal.fire({
      icon: "success",
      title: "Contacto creado",
      text: "El contacto fue creado exitosamente.",
    });
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "Hubo un error al guardar el contacto.", "error");
  }
};

 const getPaises = async () => {
  try {
    const response = await api.get(`/paises`);
    const paisesActivos = response.data.filter(pais => pais.estado === 1);
    setNombrePais(paisesActivos);
      const argentina = paisesActivos.find(p => p.Nombre === "Argentina");
    if (argentina && !IdPais) {
      setIdPais(argentina.IdPais); // Setear Argentina como predeterminado
    }
  } catch (error) {
    console.error(error);
  }
};

  const getRelaciones = async () => {
    const response = await api.get(`/tiposRelacion`);
    console.log(response.data);

    setTiposDeRelaciones(response.data);
  }

const getPatologias = async () => {
  try {
    // CAMBIA ESTA LÍNEA - usa /patologias en lugar de /getPatologias
    const response = await api.get(`/patologias`);
    const patologiasActivas = response.data.filter(p => p.estado === 1);
    setTiposDePatologia(patologiasActivas);

    console.log("📋 Patologías activas desde /patologias:", patologiasActivas);

    const idPatologiaSeleccionada = localStorage.getItem("idPatologiaSeleccionada");
    console.log("🎯 ID Patología del usuario:", idPatologiaSeleccionada);

    let patologiaEncontrada = null;

    if (patologiaActiva) {
      patologiaEncontrada = patologiasActivas.find(
        p => p.Nombre === patologiaActiva
      ) || null;
    }

    if (!patologiaEncontrada && idPatologiaSeleccionada && patologiasActivas.length > 0) {
      patologiaEncontrada = patologiasActivas.find(p =>
        p.IdPatologia?.toString() === idPatologiaSeleccionada.toString() ||
        p.idPatologia?.toString() === idPatologiaSeleccionada.toString()
      ) || null;
    }

    if (patologiaEncontrada) {
      const idSeleccionadaRaw = patologiaEncontrada.IdPatologia ?? patologiaEncontrada.idPatologia ?? idPatologiaSeleccionada;
      const idSeleccionada = Number(idSeleccionadaRaw);

      setPatologia(Number.isNaN(idSeleccionada) ? idSeleccionadaRaw : idSeleccionada);
      setPatologiaNombre(patologiaEncontrada.Nombre);
      console.log("✅ Patología asignada:", patologiaEncontrada.Nombre);
    } else if (patologiaActiva) {
      const idNumerico = idPatologiaSeleccionada ? parseInt(idPatologiaSeleccionada, 10) : NaN;
      if (!Number.isNaN(idNumerico)) {
        setPatologia(idNumerico);
      }
      setPatologiaNombre(patologiaActiva);
    } else {
      console.log("⚠️ No se encontró idPatologiaSeleccionada en localStorage");
      setPatologia("");
      setPatologiaNombre("No hay patología configurada");
    }

  } catch (err) {
    console.error("Error al obtener las patologías:", err);
    setPatologiaNombre("Error al cargar patologías");
  }
};


  const getCase = async () => {
  try {
    const y = await api.get(`/getPersonaByDocument?Nmbr=${documentCaseNumber}`);
    const persona = y.data;

   if (persona.IdClasificacionPersona === 1) {
  setPersonaCase(persona);
  setErrorCase("");
} else {
  setPersonaCase(null);
  setErrorCase("El DNI ingresado no pertenece a un caso.");
}
  } catch (err) {
    console.error(err);
    setPersonaCase(null);
    setErrorCase("Persona no encontrada");
  }
};
const esExtranjero = () => {
  const paisSeleccionado = nombrePais.find(p => p.IdPais == IdPais);
  return paisSeleccionado && paisSeleccionado.Nombre !== "Argentina"; // o IdPais !== 1 si querés por ID
};



const onSuggestionsFetchRequested = async ({ value }) => {
  if (value.length >= 2) {
    try {
      const res = await api.get(`/sugerencias/nombre-apellido`, {
        params: {
          texto: value,
          IdZonaSanitaria: zonaSanitariaUsuario.IdZonaSanitaria,
          IdPatologia: patologia
        }
      });
      console.log("🔍 Sugerencias encontradas:", res.data.length);
      setSugerencias(res.data);
    } catch (err) {
      console.error("Error al buscar sugerencias:", err);
      setSugerencias([]);
    }
  } else {
    setSugerencias([]);
  }
};


const onDniSuggestionsFetchRequested = async ({ value }) => {
  if (value.length >= 2) {
    try {
      const res = await api.get(`/sugerencias/documento`, {
        params: {
          Nmbr: value,
          IdZonaSanitaria: zonaSanitariaUsuario.IdZonaSanitaria,
          IdPatologia: patologia
        }
      });
      console.log("🔍 Sugerencias DNI encontradas:", res.data.length);
      setSugerenciasDni(res.data);
    } catch (err) {
      console.error("Error al buscar sugerencias por DNI:", err);
      setSugerenciasDni([]);
    }
  } else {
    setSugerenciasDni([]);
  }
};

const nombreCasoEvento = [personaCase?.Nombre, personaCase?.Apellido]
  .filter(Boolean)
  .join(" ")
  .trim();

useEffect(() => {
  if ((Eventos || "").trim()) {
    setMostrarEventosCampo(true);
  }
}, [Eventos]);

// Función para obtener la información de zona y patología
const obtenerInfoZonaPatologia = (sugerencia) => {
  const clasificacion = sugerencia.clasificacionesPatologia?.[0];
  if (!clasificacion) {
    return "Sin información de zona/patología";
  }

  const nombreZona = clasificacion.zonaSanitaria?.Nombre || "Zona desconocida";
  const nombrePatologia = clasificacion.patologia?.Nombre || "Patología desconocida";

  return `Zona: ${nombreZona} - Patología: ${nombrePatologia}`;
};


const obtenerCasePorIdPersona = async (idPersona) => {
  try {
    const res = await api.get(`/getPersonaById`, { params: { idPersona } });
    const persona = res.data;
    if (persona.IdClasificacionPersona === 1) {
      setPersonaCase(persona);
      setErrorCase("");
    } else {
      setPersonaCase(null);
      setErrorCase("La persona no es un caso.");
    }
  } catch (err) {
    console.error(err);
    setPersonaCase(null);
    setErrorCase("No se pudo obtener el caso.");
  }
};




  //
  const getContact = async () => {
    try {
      const y = await api.get(`/getPersonaByDocument?Nmbr=${IdDocumento}`);
      console.log(y.data);
Swal.fire({
      icon: "warning",
      title: "Documento duplicado",
      text: "Ya está registrado ese número de documento.",
    });
    setContactError("Ya está registrado ese documento!!");
  } catch (err) {
    setContactError(""); // Si no hay error, limpiar
  }
};
  const createPersona = async () => {
    try {
      const idDocumentoActual = IdDocumento;

      // 1. Crear persona
      await api.post(`/createPersona`, {
        IdPais: IdPais,
        Email: Email,
        Telefono: Telefono,
        Observaciones: Observaciones,
        Eventos: Eventos,
        Nombre: Nombre,
        Apellido: Apellido,
        NroDocumento: IdDocumento,
        FechaNacimiento: FechaNacimiento || null,
        Edad: Edad,
        IdGrupoEtario: IdGrupoEtario || null,
        IdEstablecimientoDiagnostico,
        IdSector,
        IdSubsector,
        IdAreaZona,
        IdAreaProgramatica,
        FechaApertura: desconoceFechaApertura ? null : FechaApertura || null,
        FechaNotificacion: desconoceFechaNotificacion ? null : FechaNotificacion || null,
        SemanaEpidemiologica: SemanaEpidemiologica || null,
        ClasificacionInicioTratamiento: ClasificacionInicioTratamiento.trim().toUpperCase() || null,
        FechaInicioTratamiento: desconoceFechaInicioTratamiento ? null : FechaInicioTratamiento || null,
        FechaFinTratamiento: desconoceFechaFinTratamiento ? null : FechaFinTratamiento || null,
        ResultadoTratamiento: ResultadoTratamiento.trim().toUpperCase() || null,
        IdInstitucionSeguimientoTratamiento,
        IdEvolucionClinicoTerapeutica,
        Sexo: Sexo,
        Genero: Genero,
      });

      // 2. Obtener IdPersona
      const y = await api.get(`/getPersonaByDocument`, {
        params: { Nmbr: idDocumentoActual },
      });
      const yy = y.data.IdPersona;

      // 3. Guardar domicilio si hay dirección o coordenadas (la zona es opcional)
      if (direccion || coordenadas) {
        const direccionNormalizada =
          (direccion && direccion.trim()) ||
          `Lat: ${coordenadas?.lat?.toFixed?.(5) ?? ""}, Lng: ${coordenadas?.lng?.toFixed?.(5) ?? ""}`;

        const domicilioPayload = {
          idPersona: yy,
          arrayDomicilios: [
            {
              Calle: direccionNormalizada,
              Numero: "S/N",
              Piso: null,
              Departamento: null,
              Latitud: coordenadas?.lat ?? null,
              Longitud: coordenadas?.lng ?? null,
            },
          ],
          cantidadDomicilios: 1,
          IdZonaGeografica: zonaGeografica || null,
        };
        await api.post(`/guardarDomiciliosPorPersonaGis`, domicilioPayload);
      }

      // 4. Continuar con el resto del flujo
      await stablishPersonas(yy);
    } catch (err) {
      alert(err);
      console.error(err);
      throw err;
    }
  };

const getTiposDocumentoActivosPorPais = async (idPais) => {
  try {
    const response = await api.get(`/tipodocumentos`);
    const activos = response.data.filter(doc => doc.estado === 1 && doc.IdPais == idPais);
    setTiposDocumentoPorPais(activos);
    
    const dni = activos.find(doc => doc.TipoDocumento.toLowerCase() === "dni");
    if (dni) {
      setTipoDocumento(dni.idTipoDocumento);
    } else if (activos.length === 1) {
      setTipoDocumento(activos[0].idTipoDocumento);
    } else {
      setTipoDocumento("");
    }
  } catch (error) {
    console.error("Error al obtener tipos de documento:", error);
    setTiposDocumentoPorPais([]);
  }
};
  const stablishPersonas = async (idPersonaCreada) => {
  try {
    // 1️⃣ Usar la persona creada en el paso anterior
    const zz = Number(idPersonaCreada);
    const idPatologiaNumero = Number(patologia);

    if (!zz || Number.isNaN(zz)) {
      throw new Error("No se pudo obtener IdPersona creada para clasificar");
    }
    if (!idPatologiaNumero || Number.isNaN(idPatologiaNumero)) {
      throw new Error("No se pudo determinar IdPatologia para clasificar");
    }

    console.log("Persona creada -> IdPersona:", zz);

    // 2️⃣ Clasificar contacto
    await api.post(`/ClasificarContacto`, {
      IdPersona: zz,
      IdPatologia: idPatologiaNumero,
      IdClasificacionPersona: 2,
      TipoDocumento: tipoDocumento,
      IdZonaSanitaria: zonaSanitariaUsuario ? zonaSanitariaUsuario.IdZonaSanitaria : null,
    });
    console.log("Clasificación creada");

    // 3️⃣ Relación
    await api.post(`/createRelacion`, {
      IdPersona1: zz,
      IdPersona2: personaCase.IdPersona,
      idTipoRelacion: relacion,
      conviviente: isConviviente,
    });
    console.log("Relación creada");

    // 4️⃣ Fechas seguimiento
    await api.post(`/guardarFechasSeguimiento`, {
      IdPersona: zz,
      fechaSintomas: desconoceFechaSintomas ? null : fechaSintomas,
      fechaExposicion: desconoceFechaExposicion ? null : fechaExposicion,
      fechaConsulta: desconoceFechaConsulta ? null : fechaConsulta,
    });
    console.log("Fechas de seguimiento guardadas");

    // 5️⃣ Comorbilidades
    if (comorbilidadesSeleccionadas.length > 0) {
      await asociarComorbilidadesAPersona(zz, patologia);
      console.log("Comorbilidades asociadas");
    }
if (atributosSeleccionados.length > 0) {
  await api.post('/atributosxpersonaxpatologia', {
    IdPersona: zz,
    IdPatologia: patologia, // 👈 automática
    atributos: atributosSeleccionados
  });

  console.log("✅ Atributos guardados");
}

 // 6️⃣ Guardar estado en 'estadosporpersona'
try {
  // 🔍 Obtener el estado correcto según la patología activa o columna sistema
  const idEstadoReal = await obtenerIdEstadoPorNombreOSistema();

  if (!idEstadoReal) {
    throw new Error("No se encontró un estado válido para asignar en estadosporpersona");
  }

  // ✔ Guardar estado correcto en estadosporpersona
  const respEstado = await api.post(`/estadosporpersona`, { IdPersona: zz, IdEstado: idEstadoReal });

  console.log("Estados por persona creado:", respEstado.data);
} catch (errEstado) {
  console.error(
    "Error al crear estadosporpersona:",
    errEstado?.response?.data || errEstado.message || errEstado
  );
  throw errEstado;
}

    // 7️⃣ Crear seguimiento automático
    await crearSeguimientoAutomatico(zz);

    // 8️⃣ Limpiar formulario para cargar otro contacto
    limpiarFormularioContacto();
  } catch (err) {
    console.error("Error en stablishPersonas (paso):", err?.response?.data || err.message || err);
    alert("Error al guardar el contacto. Revisá la consola y el log del backend.");
  }
};
useEffect(() => {
  console.log("🔍 DEBUG COMPLETO DEL LOCALSTORAGE:");
  console.log("idPatologiaSeleccionada:", localStorage.getItem("idPatologiaSeleccionada"));
  console.log("Tipo de idPatologiaSeleccionada:", typeof localStorage.getItem("idPatologiaSeleccionada"));
  console.log("patologiaActiva:", localStorage.getItem("patologiaActiva"));

  const id = localStorage.getItem("idPatologiaSeleccionada");
  if (id) {
    console.log("ID convertido a número:", Number(id));
    console.log("Es un número válido?", !isNaN(Number(id)));
  }

  getPatologias();
}, [patologiaActiva]);

useEffect(() => {
  if (!patologiaActiva) return;

  if (TiposDePatologia.length > 0) {
    const seleccionada = TiposDePatologia.find(p => p.Nombre === patologiaActiva);
    if (seleccionada) {
      const idSeleccionadaRaw = seleccionada.IdPatologia ?? seleccionada.idPatologia ?? "";
      const idSeleccionada = Number(idSeleccionadaRaw);
      setPatologia(Number.isNaN(idSeleccionada) ? idSeleccionadaRaw : idSeleccionada);
      setPatologiaNombre(seleccionada.Nombre || patologiaActiva);
      return;
    }
  }


  const idLocal = localStorage.getItem("idPatologiaSeleccionada");
  const idNumerico = idLocal ? parseInt(idLocal, 10) : NaN;

  if (!Number.isNaN(idNumerico)) {
    setPatologia(idNumerico);
  }

  setPatologiaNombre(patologiaActiva);
}, [patologiaActiva, TiposDePatologia]);
return (
   
    <style>
  {`
    .autosuggest-item {
      padding: 8px 12px;
      cursor: pointer;
      transition: background-color 0.2s ease-in-out;
    }

    .autosuggest-item:hover,
    .react-autosuggest__suggestion--highlighted {
      background-color: #e0f0ff;
    }

    .react-autosuggest__suggestions-container {
      border: 1px solid #ccc;
      border-radius: 4px;
      background: white;
      position: absolute;
      z-index: 10;
      width: 100%;
      box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
    }

    input:focus {
      border-color: #3273dc;
      box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.25);
      outline: none;
    }
  `}
</style>,
    
  <div className="columns mt-5 is-centered">
    <div className="column is-half">
      <label className="label" style={{ textAlign: "center" }}>
        Cargar Contactos
      </label>
      <br />

      <div>
        <label className="label">Seleccionar Caso</label>

         {!nombreCase && !apellidoCase && (
    <div className="field">
      <label className="label required">DNI del caso</label>
      <div className="control">
        <Autosuggest
          suggestions={sugerenciasDni}
          onSuggestionsFetchRequested={onDniSuggestionsFetchRequested}
          onSuggestionsClearRequested={() => setSugerenciasDni([])}
          getSuggestionValue={(sug) => sug.NroDocumento}
          renderSuggestion={(sug) => (
            <div className="autosuggest-item">
              <div className="suggestion-main">
                {sug.Nombre?.trim()} {sug.Apellido?.trim()} - {sug.NroDocumento}
              </div>
              <div className="suggestion-details">
                {obtenerInfoZonaPatologia(sug)}
              </div>
              {/* Mostrar clasificación si está disponible */}
              {sug.clasificacionesPatologia?.[0]?.IdClasificacionPersona && (
                <div className="suggestion-classification">
                  Clasificación: {sug.clasificacionesPatologia[0].IdClasificacionPersona === 1 ? 'Caso' : 'Contacto'}
                </div>
              )}
            </div>
          )}
          onSuggestionSelected={(_, { suggestion }) => {
            setDocumentCaseNumber(suggestion.NroDocumento);
            setPersonaCase(suggestion);
            setSugerenciasDni([]);
            setNombreCase("");
            setApellidoCase("");
          }}
          inputProps={{
            placeholder: "DNI del caso",
            value: documentCaseNumber,
            onChange: (_e, { newValue }) => {
              setDocumentCaseNumber(newValue);
            },
                  autoFocus: true
                }}
              />
            </div>
          </div>
        )}

        {/* Esto muestra los  datos de la persona */}
        <div className="persona-info">
  {CaseError && <p className="has-text-danger">{CaseError}</p>}
  {personaCase && (
    <div className="box">
      <p>
        <strong>Nombre:</strong> {personaCase.Nombre}
      </p>
      <p>
        <strong>Apellido:</strong> {personaCase.Apellido}
      </p>
      <p>
        <strong>DNI:</strong> {personaCase.NroDocumento}
      </p>
      {/* ✅ Agregar información de zona y patología */}
     {personaCase.clasificacionesPatologia?.[0] && (
  <>
    <p>
      <strong>Zona Sanitaria:</strong>{" "}
      {personaCase.clasificacionesPatologia[0].zonaSanitaria?.Nombre || "Desconocida"}
    </p>
    <p>
      <strong>Patología:</strong>{" "}
      {personaCase.clasificacionesPatologia[0].patologia?.Nombre || "Desconocida"}
    </p>

    <p>
      <strong>Clasificación:</strong>{" "}
      {personaCase.clasificacionesPatologia[0].IdClasificacionPersona === 1 ? "Caso" : "Contacto"}
    </p>
  </>
)}
    </div>
  )}
</div>

        <br />

        {/* Busca por nombre y apellido */}
        {!documentCaseNumber && (
  <div className="field">
    <label className="label">O buscar por nombre o apellido</label>
    <Autosuggest
      suggestions={sugerencias}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={() => setSugerencias([])}
      getSuggestionValue={(sug) =>
        `${sug.Nombre.trim()} ${sug.Apellido.trim()} - ${sug.NroDocumento}`
      }
      renderSuggestion={(sug) => (
        <div className="autosuggest-item">
          <div className="suggestion-main">
            {sug.Nombre.trim()} {sug.Apellido.trim()} - {sug.NroDocumento}
          </div>
          <div className="suggestion-details">
            {obtenerInfoZonaPatologia(sug)}
          </div>
          {/* Mostrar clasificación si está disponible */}
          {sug.clasificacionesPatologia?.[0]?.IdClasificacionPersona && (
            <div className="suggestion-classification">
              Clasificación: {sug.clasificacionesPatologia[0].IdClasificacionPersona === 1 ? 'Caso' : 'Contacto'}
            </div>
          )}
        </div>
      )}
      onSuggestionSelected={(_, { suggestion }) => {
        setNombreCase(suggestion.Nombre.trim());
        setApellidoCase(suggestion.Apellido.trim());
        setPersonaCase(suggestion);
        setErrorCase("");
        setDocumentCaseNumber("");
      }}
      inputProps={{
        placeholder: "Buscar caso por nombre o apellido",
        value: nombreCase,
        onChange: (_e, { newValue }) => {
          setNombreCase(newValue);
        }
      }}
    />
  </div>
)}


       <label className="label seccion-titulo">Información del Contacto</label>

<div
  className="form-grid"
  style={{
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "16px 20px",
  }}
>
  {/* ZONA SANITARIA */}
  <div className="field">
    <label className="label required">Zona Sanitaria</label>
    {zonaSanitariaUsuario ? (
      <>
        <input
          type="text"
          className="input"
          value={
            zonas.find(
              (z) =>
                z.IdZonaSanitaria === zonaSanitariaUsuario.IdZonaSanitaria
            )?.Nombre || ""
          }
          readOnly
          style={{
            backgroundColor: "#f5f5f5",
            cursor: "not-allowed",
            border: "2px solid #3273dc",
            fontWeight: "bold",
          }}
        />
        <p
          className="text-success mt-1"
          style={{ fontWeight: "500", color: "#14532d" }}
        >
          ✅ Zona Sanitaria cargada automáticamente desde tu perfil
        </p>
        <input type="hidden" value={zonaSanitariaUsuario.IdZonaSanitaria} required />
      </>
    ) : (
      <select
        className="input"
        value={
          zonaSanitariaUsuario
            ? zonaSanitariaUsuario.IdZonaSanitaria
            : ""
        }
        onChange={(e) =>
          setZonaSanitariaUsuario({
            IdZonaSanitaria: e.target.value,
          })
        }
        required
      >
        <option value="">Seleccione una zona</option>
        {zonas.map((z) => (
          <option key={z.IdZonaSanitaria} value={z.IdZonaSanitaria}>
            {z.Nombre}
          </option>
        ))}
      </select>
    )}
  </div>

  {/* NACIONALIDAD */}
  <div className="field">
    <label className="label required">Nacionalidad</label>
    <div className="select is-fullwidth">
      <select
        value={IdPais}
        onChange={(e) => setIdPais(e.target.value)}
        onClick={getPaises}
        required
      >
        <option value="">Seleccionar</option>
        {nombrePais.map((NombrePais) => (
          <option key={NombrePais.IdPais} value={NombrePais.IdPais}>
            {NombrePais.Nombre}
          </option>
        ))}
      </select>
    </div>
  </div>

  {/* PATOLOGÍA */}
  <div className="field">
    <label className="label required">Patología</label>
    <div className="control">
      <input
        type="text"
        className="input"
        value={patologiaNombre}
        readOnly
        style={{
          backgroundColor: "#f5f5f5",
          cursor: "not-allowed",
          border: "2px solid #3273dc",
          fontWeight: "bold",
        }}
      />
    </div>
    <p
      className="text-success mt-1"
      style={{ fontWeight: "500", color: "#14532d" }}
    >
      ✅ Patología cargada automáticamente desde tu perfil
    </p>
    <input type="hidden" value={patologia} required />
  </div>

  {/* COMORBILIDADES */}
  {comorbilidadesDisponibles.length > 0 && (
    <div className="field">
      <label className="label">Comorbilidades (seleccione una o varias)</label>
      <div
        className="box"
        style={{
          maxHeight: "200px",
          overflowY: "auto",
          border: "1px solid #d1d5db",
          borderRadius: "6px",
          padding: "0.75rem",
          backgroundColor: "#f9fafb",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "6px 12px",
        }}
      >
        {[...comorbilidadesDisponibles]
          .sort((a, b) => a.Nombre.localeCompare(b.Nombre))
          .map((com) => (
            <label
              key={com.IdComorbilidad}
              className="checkbox"
              style={{
                display: "flex",
                alignItems: "center",
                padding: "4px 0",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              <input
                type="checkbox"
                value={com.IdComorbilidad}
                checked={comorbilidadesSeleccionadas.includes(
                  com.IdComorbilidad.toString()
                )}
                onChange={(e) => {
                  const id = e.target.value;
                  setComorbilidadesSeleccionadas((prev) =>
                    e.target.checked
                      ? [...prev, id]
                      : prev.filter((c) => c !== id)
                  );
                }}
                style={{ marginRight: "8px" }}
              />
              {com.Nombre}
            </label>
          ))}
      </div>

      {comorbilidadesSeleccionadas.length > 0 && (
        <p
          className="help"
          style={{
            marginTop: "6px",
            color: "#2563eb",
            fontWeight: "500",
          }}
        >
          Seleccionadas:{" "}
          {[...comorbilidadesDisponibles]
            .filter((c) =>
              comorbilidadesSeleccionadas.includes(
                c.IdComorbilidad.toString()
              )
            )
            .map((c) => c.Nombre)
            .sort((a, b) => a.localeCompare(b))
            .join(", ")}
        </p>
      )}
    </div>
  )}

  {/* SIN COMORBILIDADES */}
  {patologia && comorbilidadesDisponibles.length === 0 && (
    <div className="field">
      <label className="label">Comorbilidades</label>
      <div className="notification is-info is-light">
        No hay comorbilidades registradas para la patología{" "}
        <strong>{patologiaNombre}</strong>
      </div>
    </div>
  )}

{/* ATRIBUTOS DE LA PATOLOGÍA */}
{patologia && atributosDisponibles.length > 0 && (
  <div className="field">
    <label className="label">
      Atributos de la patología <strong>{patologiaNombre}</strong>
    </label>

    <div
      className="box"
      style={{
        maxHeight: "200px",
        overflowY: "auto",
        border: "1px solid #d1d5db",
        borderRadius: "6px",
        padding: "0.75rem",
        backgroundColor: "#f9fafb",
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "6px 12px",
      }}
    >
   {atributosDisponibles.map(attr => (
  <label key={attr.IdAtributo} className="checkbox-item">
    <input
      type="checkbox"
      value={attr.IdAtributo}
      checked={atributosSeleccionados.includes(attr.IdAtributo)}
      onChange={(e) => {
        const id = Number(e.target.value);
        setAtributosSeleccionados(prev =>
          prev.includes(id)
            ? prev.filter(a => a !== id)
            : [...prev, id]
        );
      }}
    />
    {attr.NombreAtributo}
  </label>
))}
    </div>
  </div>
)}




  {/* TIPO DE DOCUMENTO */}
  {IdPais !== "" && IdPais !== 0 && (
    <div className="field" style={{ gridColumn: "1 / span 2" }}>
      <label className="label required">Tipo de Documento</label>
      <div className="select is-fullwidth">
        <select
          value={tipoDocumento}
          onChange={(e) => setTipoDocumento(e.target.value)}
          required
        >
          <option value="">Seleccionar</option>
          {tiposDocumentoPorPais.map((tipo) => (
            <option key={tipo.idTipoDocumento} value={tipo.idTipoDocumento}>
              {tipo.TipoDocumento}
            </option>
          ))}
        </select>
      </div>
    </div>
  )}

  {/* NÚMERO DE DOCUMENTO Y MENSAJE */}
  <div className="field documento-field" style={{ gridColumn: "1 / span 2" }}>
    <div className="documento-grid">
      <div className="campo-dni">
        <label className="label required">Número de Documento</label>
        <div className="control">
          <input
            type="text"
            className="input"
            value={IdDocumento}
               onChange={(e) => {
            // 🔢 Solo números (elimina cualquier letra o símbolo)
            const soloNumeros = e.target.value.replace(/\D/g, "");
            setIdDocumento(soloNumeros);
          }}
          onBlur={() => BuscarContactoExistente(IdDocumento)}
          placeholder="Número de Documento"
          required
          maxLength={8} // límite de 8 dígitos
          pattern="^[0-9]+$"
          title="Solo se permiten números"
          />
        </div>
      </div>

      {/* MENSAJE DE VALIDACIÓN */}
      {mensaje && (
        <div
          className={`mensaje-cuadro ${bloquear ? "bloqueo" : "informativo"}`}
          style={{ whiteSpace: "pre-line" }}
        >
          {mensaje}
        </div>
      )}
    </div>
  </div>

  {/* Localidad/Dirección (Leaflet) */}
  <div className="field">
    <label className="label required">Localidad / Dirección</label>
    <div className="control" style={{ display: "flex", gap: "8px" }}>
      <input
        type="text"
        className="input"
        value={direccion}
        placeholder="Seleccione en el mapa"
        readOnly
        required
        style={{ background: "#f3f4f6", cursor: "pointer" }}
        onClick={handleAbrirMapa}
      />
      <button type="button" className="button is-info" onClick={handleAbrirMapa}>
        Seleccionar en mapa
      </button>
    </div>
    {coordenadas && (
      <p className="help" style={{ color: "#2563eb" }}>
        Lat: {coordenadas.lat}, Lng: {coordenadas.lng}
      </p>
    )}
  </div>

  {/* Modal del mapa con Leaflet */}
  <Modal
    isOpen={modalMapaAbierto}
    onRequestClose={handleCerrarMapa}
    contentLabel="Seleccionar Localidad/Dirección"
    ariaHideApp={false}
    style={{
      overlay: { zIndex: 1000, background: "rgba(0,0,0,0.4)" },
      content: { maxWidth: 600, margin: "auto", borderRadius: 12 }
    }}
  >
    <h2>Seleccionar Localidad / Dirección</h2>
    {/* Buscador de dirección con autocompletado */}
    <div style={{ marginBottom: 18, position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <label className="label" style={{ fontSize: '15px', marginBottom: 6, color: '#2563eb', fontWeight: 600 }}>Buscar dirección</label>
      <input
        type="text"
        className="input"
        style={{ fontSize: '15px', padding: '8px 14px', height: 36, minHeight: 0, maxWidth: 400, border: '1.5px solid #2563eb', borderRadius: 8, boxShadow: '0 2px 8px #e0e7ff' }}
        value={direccion}
        onChange={e => {
          setDireccion(e.target.value);
          if (timeoutDireccion) {
            clearTimeout(timeoutDireccion.current);
          }
          if (!e.target.value || e.target.value.length < 3) {
            setSugerenciasDireccion([]);
            return;
          }
          setBuscandoDireccion(true);
          timeoutDireccion.current = setTimeout(async () => {
            try {
              const resp = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(e.target.value)}&addressdetails=1&limit=5`);
              const data = await resp.json();
              setSugerenciasDireccion(data);
            } catch (e) {
              setSugerenciasDireccion([]);
            } finally {
              setBuscandoDireccion(false);
            }
          }, 400);
        }}
        placeholder="Escriba la dirección o selecciónela en el mapa"
        autoComplete="off"
      />
      {buscandoDireccion && (
        <div style={{ position: 'absolute', top: 48, left: 0, right: 0, background: '#fff', zIndex: 10, padding: 10, border: '1.5px solid #2563eb', borderRadius: 8, fontSize: 14, color: '#2563eb', boxShadow: '0 2px 8px #e0e7ff' }}>
          Buscando...
        </div>
      )}
      {sugerenciasDireccion && sugerenciasDireccion.length > 0 && (
        <ul style={{ position: 'absolute', top: 48, left: 0, right: 0, background: '#fff', zIndex: 10, listStyle: 'none', margin: 0, padding: 0, border: '1.5px solid #2563eb', borderRadius: 8, maxHeight: 180, overflowY: 'auto', boxShadow: '0 2px 8px #e0e7ff' }}>
          {sugerenciasDireccion.map((s, idx) => (
            <li
              key={s.place_id}
              style={{ padding: '10px 16px', cursor: 'pointer', fontSize: 14, borderBottom: idx !== sugerenciasDireccion.length - 1 ? '1px solid #e0e7ff' : 'none', transition: 'background 0.2s' }}
              onClick={() => {
                setDireccion(s.display_name);
                setCoordenadas({ lat: parseFloat(s.lat), lng: parseFloat(s.lon) });
                setSugerenciasDireccion([]);
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#f0f9ff'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}
            >
              {s.display_name}
            </li>
          ))}
        </ul>
      )}
    </div>
    {/* Mapa */}
    <div style={{ height: 350, borderRadius: 16, marginBottom: 18, boxShadow: '0 4px 16px #e0e7ff', border: '2px solid #2563eb' }}>
      <MapContainer
        center={coordenadas || [-34.6037, -58.3816]}
        zoom={15}
        style={{ height: "100%", width: "100%", borderRadius: 16 }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LocationMarker />
      </MapContainer>
    </div>
    <div style={{ marginBottom: 12, color: '#2563eb', fontWeight: 500 }}>
      {coordenadas ? `Ubicación seleccionada: Lat ${coordenadas.lat.toFixed(5)}, Lng ${coordenadas.lng.toFixed(5)}` : 'Hacé click en el mapa para seleccionar una ubicación.'}
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
      <button className="button is-success" style={{ minWidth: 120, fontWeight: 600, fontSize: 15 }} onClick={handleSeleccionarDireccion} disabled={!coordenadas}>
        Usar esta ubicación
      </button>
      <button className="button" style={{ minWidth: 100, fontWeight: 500, fontSize: 15 }} onClick={handleCerrarMapa}>
        Cancelar
      </button>
    </div>
  </Modal>

  {/* NOMBRE */}
  <div className="field" style={{ gridColumn: "1 / span 2" }}>
    <label className="label required">Nombre</label>
    <div className="control">
      <input
        type="text"
        className="input"
        value={Nombre}
        onChange={(e) => setNombre(e.target.value)}
        placeholder="Nombre"
        required
      />
    </div>
  </div>

  {/* ESTILOS */}
  <style jsx>{`
    .form-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px 20px;
    }
    @media (max-width: 768px) {
      .form-grid {
        grid-template-columns: 1fr;
      }
    }
    .label {
      font-weight: 600;
      display: block;
      margin-bottom: 5px;
    }
    .required::after {
      content: " *";
      color: red;
    }
    .input,
    .select select {
      width: 100%;
      padding: 8px;
      border-radius: 8px;
      border: 1px solid #ccc;
      font-size: 14px;
    }
    .documento-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
      align-items: start;
    }
    .mensaje-cuadro {
      background: #ffffff;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      padding: 12px 14px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
      line-height: 1.4;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }
    .mensaje-cuadro.bloqueo {
      border: 1px solid #e74c3c;
      background: #fdecea;
      color: #c0392b;
    }
    .mensaje-cuadro.informativo {
      border: 1px solid #27ae60;
      background: #eafaf1;
      color: #14532d;
    }
  `}</style>

  
</div>

          <div className="event-inline-row">
            <div className="field">
              <label className="label required">Apellido</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  //pattern="[a-z A-Z ñ]{2,20}"
                  value={Apellido}
                  onChange={(e) => setApellido(e.target.value)}
                  placeholder="Apellido"
                  required/*="Por favor escriba un nombre valido"*/
                />
              </div>
            </div>

            <div className="field event-inline-events">
              <div className="event-inline-control-row">
                <button
                  type="button"
                  className="event-inline-trigger"
                  onClick={() => setMostrarEventosCampo((prev) => !prev)}
                >
                  Eventos
                </button>

                {mostrarEventosCampo && (
                  <div className="event-inline-panel-right">
                    <div className="event-inline-panel-actions">
                      <button
                        type="button"
                        className="event-inline-close"
                        onClick={() => setMostrarEventosCampo(false)}
                      >
                        Ocultar
                      </button>
                    </div>
                    <EventTagInput
                      value={Eventos}
                      onChange={setEventos}
                      caseDisplayName={nombreCasoEvento}
                      placeholder="Agregar evento"
                      compact
                      showHint={false}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="field">
            <label className="label">Fecha de nacimiento</label>
            <div className="control">
              <input type="date" className="input" value={FechaNacimiento} max={fechaActual} onChange={(e) => actualizarFechaNacimiento(e.target.value)} />
            </div>
            <p className="help">Opcional. Al ingresarla se calcula la edad automáticamente.</p>
          </div>

          <div className="field">
            <label className="label required">Edad</label>
            <div className="control">
              <input
                type="number"
                max="120"
                min="0"
                pattern="^[1-9]"
                className="input"
                value={Edad}
                onChange={(e) => setEdad(e.target.value)}
                placeholder="edad"
                required
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Grupo etario</label>
            <div className="control">
              <div className="select is-fullwidth">
                <select value={IdGrupoEtario} onChange={(e) => setIdGrupoEtario(e.target.value)}>
                  <option value="">Sin asignar</option>
                  {gruposEtarios.map((grupo) => (
                    <option key={grupo.IdGrupoEtario} value={grupo.IdGrupoEtario}>
                      {grupo.Nombre} ({grupo.EdadDesde} a {grupo.EdadHasta} años)
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <p className="help">Se sugiere automáticamente según la edad y puede modificarse.</p>
          </div>
          <div className="field">
            <label className="label required">Establecimiento de diagnóstico</label>
            <div className="control"><div className="select is-fullwidth">
              <select value={IdEstablecimientoDiagnostico} onChange={(e) => setIdEstablecimientoDiagnostico(e.target.value)} required>
                <option value="">Seleccionar establecimiento</option>
                {establecimientosDiagnostico.map((item) => <option key={item.IdEstablecimientoDiagnostico} value={item.IdEstablecimientoDiagnostico}>{item.Nombre}</option>)}
              </select>
            </div></div>
          </div>
          <div className="field">
            <label className="label required">Sector</label>
            <div className="control"><div className="select is-fullwidth"><select value={IdSector} onChange={(e) => { setIdSector(e.target.value); setIdSubsector(""); }} required>
              <option value="">Seleccionar sector</option>
              {sectores.map((item) => <option key={item.IdSector} value={item.IdSector}>{item.Nombre}</option>)}
            </select></div></div>
          </div>
          <div className="field">
            <label className="label">Subsector</label>
            <div className="control"><div className="select is-fullwidth"><select value={IdSubsector} onChange={(e) => setIdSubsector(e.target.value)} disabled={!IdSector}>
              <option value="">Sin asignar</option>
            {subsectores.filter((item) => Number(item.IdSector) === Number(IdSector)).map((item) => <option key={item.IdSubsector} value={item.IdSubsector}>{item.Nombre}</option>)}
          </select></div></div>
        </div>
        <div className="field">
          <label className="label required">Zona</label>
          <div className="control"><div className="select is-fullwidth"><select value={IdAreaZona} onChange={(e) => { setIdAreaZona(e.target.value); setIdAreaProgramatica(""); }} required>
            <option value="">Seleccionar zona</option>
            {areasZonas.map((item) => <option key={item.IdAreaZona} value={item.IdAreaZona}>{item.Nombre}</option>)}
          </select></div></div>
        </div>
        <div className="field">
          <label className="label">Área programática</label>
          <div className="control"><div className="select is-fullwidth"><select value={IdAreaProgramatica} onChange={(e) => setIdAreaProgramatica(e.target.value)} disabled={!IdAreaZona}>
            <option value="">Sin área programática</option>
            {areasProgramaticas.filter((item) => Number(item.IdAreaZona) === Number(IdAreaZona)).map((item) => <option key={item.IdAreaProgramatica} value={item.IdAreaProgramatica}>{item.Nombre}</option>)}
          </select></div></div>
        </div>
          <div className="field">
            <label className="label required">Institución de seguimiento del tratamiento</label>
            <div className="control"><div className="select is-fullwidth"><select value={IdInstitucionSeguimientoTratamiento} onChange={(e) => setIdInstitucionSeguimientoTratamiento(e.target.value)} required>
              <option value="">Seleccionar institución</option>
              {institucionesSeguimientoTratamiento.map((item) => <option key={item.IdInstitucionSeguimientoTratamiento} value={item.IdInstitucionSeguimientoTratamiento}>{item.Nombre}</option>)}
            </select></div></div>
          </div>
          <div className="field">
            <label className="label required">Evolución clínico-terapéutica del tratamiento</label>
            <div className="control"><div className="select is-fullwidth"><select value={IdEvolucionClinicoTerapeutica} onChange={(e) => setIdEvolucionClinicoTerapeutica(e.target.value)} required>
              <option value="">Seleccionar evolución</option>
              {evolucionesClinicoTerapeuticas.map((item) => <option key={item.IdEvolucionClinicoTerapeutica} value={item.IdEvolucionClinicoTerapeutica}>{item.Nombre}</option>)}
            </select></div></div>
          </div>



          <div className="field">
            <label className="label required">Sexo</label>
            <div className="control">
              <div className="select is-fullwidth">
                <select
                  value={Sexo}
                  onChange={(e) => setSexo(e.target.value)}
                  placeholder="Seleccionar"

                  required>
                  <option value="">Seleccionar</option>
                  <option value={"Masculino"}> Masculino </option>
                  <option value={"Femenino"}> Femenino </option>

                </select>
              </div>
            </div>
          </div>

          <div className="field">
  <label className="label required">Género</label>
  <div className="control">
    <div className="select is-fullwidth">
      <select
        value={Genero}
        onChange={(e) => setGenero(e.target.value)}
        required
      >
        <option value="">Seleccione género</option>
        <option value="Desconocido">Desconocido</option>
        <option value="Mujer cis">Mujer cis</option>
        <option value="Mujer trans">Mujer trans</option>
        <option value="Varón cis">Varón cis</option>
        <option value="Varón trans">Varón trans</option>
        <option value="Otro">Otro</option>
      </select>
    </div>
  </div>
</div>
          <div className="field">
            <label className="label">Email</label>
            <div className="control">
              <input
                type="email"
                className="input"
                value={Email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
              />
            </div>
          </div>

          <div className="field">
            <label className="label required">Teléfono</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={Telefono}
                onChange={(e) => setTelefono(e.target.value)}
                placeholder="Teléfono"
                required
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Observaciones</label>
            <div className="control">
              <textarea
                className="textarea"
                value={Observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
                placeholder="Observaciones clínicas"
                rows={3}
              />
            </div>
          </div>

          <div className="field">
            <label className="label required">Relación</label>
            <div className="select is-fullwidth">
              <select
                value={relacion}
                onChange={(e) => setRelacion(e.target.value)}
                onClick={getRelaciones}
                key={TiposDeRelaciones.IdTipoRelacion}
                required
              >
                <option value="">Seleccionar</option>
                {TiposDeRelaciones.map((rel) => (
  <option key={rel.idTipoRelacion} value={rel.idTipoRelacion}>
    {rel.nombre}
  </option>
))}
              </select>
            </div>
          </div>



          

          <div className="field">
            <label className="label">¿Es Conviviente?</label>
            <div className="control">
              <input
                type="checkbox"
                checked={isConviviente}
                onChange={(e) => setIsConviviente(e.target.checked)}
              />
            </div>
          </div>


        <div className="field">
          <label className="label">Fecha de apertura</label>
          <div className="control"><input type="date" className="input" value={FechaApertura} onChange={(e) => setFechaApertura(e.target.value)} disabled={desconoceFechaApertura} style={{ backgroundColor: desconoceFechaApertura ? "#e0e0e0" : "white" }} max={fechaActual} /><label className="checkbox ml-2"><input type="checkbox" checked={desconoceFechaApertura} onChange={(e) => { setDesconoceFechaApertura(e.target.checked); if (e.target.checked) setFechaApertura(""); }} /> Se desconoce la fecha</label></div>
        </div>
        <div className="field">
          <label className="label">Fecha de notificación</label>
          <div className="control"><input type="date" className="input" value={FechaNotificacion} onChange={(e) => { const valor = e.target.value; setFechaNotificacion(valor); setSemanaEpidemiologica(calcularSemanaEpidemiologica(valor)); }} disabled={desconoceFechaNotificacion} style={{ backgroundColor: desconoceFechaNotificacion ? "#e0e0e0" : "white" }} max={fechaActual} /><label className="checkbox ml-2"><input type="checkbox" checked={desconoceFechaNotificacion} onChange={(e) => { setDesconoceFechaNotificacion(e.target.checked); if (e.target.checked) { setFechaNotificacion(""); setSemanaEpidemiologica(""); } }} /> Se desconoce la fecha</label></div>
        </div>
        <div className="field">
          <label className="label">Semana epidemiológica</label>
          <div className="control"><input type="number" className="input" min="1" max="53" value={SemanaEpidemiologica} onChange={(e) => setSemanaEpidemiologica(e.target.value)} placeholder="1 a 53" /></div>
          <p className="help">Se calcula automáticamente desde la fecha de notificación y puede corregirse.</p>
        </div>
        <div className="field">
          <label className="label">Clasificación inicio tratamiento</label>
          <div className="control"><div className="select is-fullwidth"><select value={ClasificacionInicioTratamiento} onChange={(e) => setClasificacionInicioTratamiento(e.target.value)}><option value="">Sin asignar</option>{estadosTratamiento.filter((item) => !item.CampoAplicacion || item.CampoAplicacion === "CLASIFICACION_INICIO" || item.CampoAplicacion === "AMBOS").map((item) => <option key={item.IdEstadoTratamientoPorPatologia} value={item.Nombre}>{item.Nombre}</option>)}</select></div></div>
        </div>
        <div className="field">
          <label className="label">Resultado del tratamiento</label>
          <div className="control"><div className="select is-fullwidth"><select value={ResultadoTratamiento} onChange={(e) => setResultadoTratamiento(e.target.value)}><option value="">Sin asignar</option>{estadosTratamiento.filter((item) => !item.CampoAplicacion || item.CampoAplicacion === "RESULTADO" || item.CampoAplicacion === "AMBOS").map((item) => <option key={item.IdEstadoTratamientoPorPatologia} value={item.Nombre}>{item.Nombre}</option>)}</select></div></div>
        </div>

        <div className="field">
  <label className="label required">Seleccione la fecha de probable exposición</label>
  <div className="control">
    <input
      type="date"
      className="input"
      value={fechaExposicion}
      onChange={validarFechaExposicion}
      disabled={desconoceFechaExposicion}
      style={{ backgroundColor: desconoceFechaExposicion ? "#e0e0e0" : "white" }}
      max={fechaActual}
    />
    {errorFechaExposicion && <p className="has-text-danger mt-1">{errorFechaExposicion}</p>}
    <label className="checkbox ml-2">
      <input
        type="checkbox"
        checked={desconoceFechaExposicion}
        onChange={(e) => setDesconoceFechaExposicion(e.target.checked)}
      />{" "}
      Se desconoce la fecha
    </label>
  </div>
</div>

         <div className="field">
  <label className="label required">Seleccione la fecha de inicio de síntomas</label>
  <div className="control">
    <input
      type="date"
      className="input"
      value={fechaSintomas}
      onChange={validarFechaSintomas}
      disabled={desconoceFechaSintomas}
      style={{ backgroundColor: desconoceFechaSintomas ? "#e0e0e0" : "white" }}
      max={fechaActual}
    />
    {errorFechaSintomas && <p className="has-text-danger mt-1">{errorFechaSintomas}</p>}
    <label className="checkbox ml-2">
      <input
        type="checkbox"
        checked={desconoceFechaSintomas}
        onChange={(e) => setDesconoceFechaSintomas(e.target.checked)}
      />{" "}
      Se desconoce la fecha
    </label>
  </div>
</div>




         <div className="field">
  <label className="label required">Seleccione la fecha de primera consulta</label>
  <div className="control">
    <input
      type="date"
      className="input"
      value={fechaConsulta}
      onChange={validarFechaConsulta}
      disabled={desconoceFechaConsulta}
      style={{ backgroundColor: desconoceFechaConsulta ? "#e0e0e0" : "white" }}
      max={fechaActual}
    />
    {errorFechaConsulta && <p className="has-text-danger mt-1">{errorFechaConsulta}</p>}
    <label className="checkbox ml-2">
      <input
        type="checkbox"
        checked={desconoceFechaConsulta}
        onChange={(e) => setDesconoceFechaConsulta(e.target.checked)}
      />{" "}
      Se desconoce la fecha
    </label>
  </div>
</div>
          <div className="field">
            <label className="label">Fecha inicio de tratamiento</label>
            <div className="control"><input type="date" className="input" value={FechaInicioTratamiento} onChange={(e) => { setFechaInicioTratamiento(e.target.value); if (FechaFinTratamiento && FechaFinTratamiento < e.target.value) setFechaFinTratamiento(""); }} disabled={desconoceFechaInicioTratamiento} style={{ backgroundColor: desconoceFechaInicioTratamiento ? "#e0e0e0" : "white" }} max={fechaActual} /><label className="checkbox ml-2"><input type="checkbox" checked={desconoceFechaInicioTratamiento} onChange={(e) => { setDesconoceFechaInicioTratamiento(e.target.checked); if (e.target.checked) setFechaInicioTratamiento(""); }} /> Se desconoce la fecha</label></div>
          </div>
          <div className="field">
            <label className="label">Fecha fin de tratamiento</label>
            <div className="control"><input type="date" className="input" value={FechaFinTratamiento} onChange={(e) => setFechaFinTratamiento(e.target.value)} disabled={desconoceFechaFinTratamiento} style={{ backgroundColor: desconoceFechaFinTratamiento ? "#e0e0e0" : "white" }} min={FechaInicioTratamiento || undefined} max={fechaActual} /><label className="checkbox ml-2"><input type="checkbox" checked={desconoceFechaFinTratamiento} onChange={(e) => { setDesconoceFechaFinTratamiento(e.target.checked); if (e.target.checked) setFechaFinTratamiento(""); }} /> Se desconoce la fecha</label></div>
          </div>
          <button onClick={Subir} className="button is-success" style={{ marginLeft: "45%" }} >Enviar</button>

        </div>
      </div>
    </div>
  );
}

export default AddContactos;
